<template>
  <div class="dy-image" :class="{'loading': loading, 'error': error, 'loaded': !loading && !error, 'code-type': codeType, 'large': size === 'large'}" @click="handleClick">
    <a-icon type="loading"></a-icon>
    <a-icon type="exclamation"></a-icon>
    <img :src="src" v-if="src">
    <a :href="src" target="_blank" class="zoom" @click.stop v-if="preview">
      <a-icon type="zoom-in"></a-icon>
    </a>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'DyImage',
    props: {
      preview: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'normal'
      },
      src: {
        type: String,
        default: null
      },
      codeType: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        error: false
      }
    },
    watch: {
      src: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.loading = true;
            this.error = false;
            this.load();
          }
        },
        immediate: true
      }
    },
    methods: {
      load() {
        let img = new Image();
        img.src = this.src;
        img.onload = () => {
          this.loading = false;
          this.error = false;
        }
        img.onerror = () => {
          this.loading = false;
          this.error = true;
        }
      },
      handleClick() {
        this.$emit('click');
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .dy-image {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    width: 100px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .zoom {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .4);
      border-radius: 4px;
      color: #FFFFFF;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > * {
      display: none;
    }
    &.code-type {
      &.large {
        height: @input-height-lg;
      }
      height: @input-height-base;
      cursor: pointer;
      img {
        width: initial;
        border-radius: @border-radius-base;
      }
    }
    &.loading {
      .anticon-loading {
        display: block;
        color: @primary-color;
      }
    }
    &.error {
      .anticon-exclamation {
        display: block;
        color: @disabled-color;
      }
    }
    &.loaded {
      img {
        display: block;
      }
      .zoom {
        display: flex;
      }
    }
  }
</style>